var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorOpenAttempt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_833_822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1245 9.28214C8.08273 8.30338 5.56131 8.65988 3.86956 10.3516C1.72408 12.4971 1.72408 15.9843 3.86956 18.1298C6.01504 20.2753 9.50225 20.2753 11.6477 18.1298C13.3395 16.4381 13.696 13.9166 12.7172 11.8749L15.5368 9.05527L18.1295 11.648L20.7223 9.05527L18.1295 6.46255L19.4259 5.16619L16.8332 2.57346L10.1245 9.28214ZM9.05501 15.5371C8.34201 16.2501 7.17528 16.2501 6.46228 15.5371C5.74928 14.8241 5.74928 13.6574 6.46228 12.9444C7.17528 12.2314 8.34201 12.2314 9.05501 12.9444C9.768 13.6574 9.768 14.8241 9.05501 15.5371Z",
    fill: "#14AC63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_833_822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorOpenAttempt);
export default __webpack_public_path__ + "static/media/DoorOpenAttempt.6bbf7ec6e7236202b7dfc40df146d73b.svg";
export { ForwardRef as ReactComponent };